import { render, staticRenderFns } from "./Scope.vue?vue&type=template&id=13f0c399"
import script from "./Scope.vue?vue&type=script&lang=js"
export * from "./Scope.vue?vue&type=script&lang=js"
import style0 from "./Scope.vue?vue&type=style&index=0&id=13f0c399&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports